// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type CheckCircle48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckCircle48: FC<CheckCircle48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="49"
            height="48"
        >
            <path d="m21.495 33.1 14.15-14.15-2.3-2.25-11.85 11.85-6-6-2.25 2.25 8.25 8.3Zm2.95 10.9c-2.733 0-5.317-.525-7.75-1.575-2.433-1.05-4.558-2.483-6.375-4.3-1.817-1.817-3.25-3.942-4.3-6.375-1.05-2.433-1.575-5.017-1.575-7.75 0-2.767.525-5.367 1.575-7.8 1.05-2.433 2.483-4.55 4.3-6.35 1.817-1.8 3.942-3.225 6.375-4.275C19.128 4.525 21.712 4 24.445 4c2.767 0 5.367.525 7.8 1.575 2.433 1.05 4.55 2.475 6.35 4.275 1.8 1.8 3.225 3.917 4.275 6.35 1.05 2.433 1.575 5.033 1.575 7.8 0 2.733-.525 5.317-1.575 7.75-1.05 2.433-2.475 4.558-4.275 6.375-1.8 1.817-3.917 3.25-6.35 4.3-2.433 1.05-5.033 1.575-7.8 1.575Zm0-3c4.733 0 8.75-1.658 12.05-4.975 3.3-3.317 4.95-7.325 4.95-12.025 0-4.733-1.65-8.75-4.95-12.05-3.3-3.3-7.317-4.95-12.05-4.95-4.7 0-8.708 1.65-12.025 4.95-3.317 3.3-4.975 7.317-4.975 12.05 0 4.7 1.658 8.708 4.975 12.025C15.737 39.342 19.745 41 24.445 41Z" />
        </svg>
    );
};

export default CheckCircle48;
